import React from "react";

const Footer = () => {
  return (
    <footer id="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="copyright">&copy; 2021 Kgatle Developer</div>
          </div>
          <div class="col-sm-6">
            <div class="designed-by">
              Designed By{" "}
              <a href=".main-info" target="_blank">
                Kgatle Johannes
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
